<template>
    <div>
        <el-popover ref="popover-org-tree" placement="top-start" trigger="click">
            <div class="popover-tree">
                <div class="hint block row">
                    <i class="icon iconfont icon-tongzhi1 mr10 font-gold"></i>
                    <span>温馨提示：鼠标双击选中</span>
                </div>
                <div class="tab-container small base">
                    <div class="tabs-nav">
                        <ul class="head">
                            <li :class="{'current': status.value == checkStateValue}" class="head-item" v-for="status in tableState" @click="handleTabClick(status.value)">
                                <span>{{status.text}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="checkStateValue == 0">
                    <swb-org-tree :bizDepart="bizDepart || departFlag" :includeUnOpenedFlag="includeUnOpenedFlag" :isSelectThisLevel="isSelectThisLevel" :dblclickFlag="true" :isCom="isCom" :accordion="accordion" :enableSearch="true" :isShowIcon="false" :closedComSelect="closedComSelect" :comFlag="comFlag" :deaprtFlag="deaprtFlag" @notity-change="notityChange($event)" @notity-init-change="notityInitChange($event)"></swb-org-tree>
                </div>
                <div v-else>
                    <swb-real-com-tree :enableSearch="true" :accordion="accordion" :dblclickFlag="true" :costFlag="costFlag" :prftFlag="prftFlag" :selectRealComId="selectRealComId" @notity-change="notityChange($event)" @notity-init-change="notityInitChange($event)"></swb-real-com-tree>
                </div>
            </div>
            <div v-show="showFlag" class="org-tree-btn" slot="reference">
                <span>选择机构</span>
                <i class="icon iconfont icon-down-sanjiao"></i>
            </div>
        </el-popover>
        <div class="org-tree-factor">
            <div class="factor-item">
                <span v-if="showFlag">【选中机构】</span>
                <span v-if="!showFlag">【当前机构】</span>
                <span v-if="itemInfo.id != null">{{displayName}}</span>
                <span v-else>无</span>
            </div>
            <div v-show="itemInfo.level <= 4 && checkStateValue == 0" class="factor-item">
                <el-checkbox v-if="showIncludeSubComs == true" v-model="includeSubComs" @change="handleCheckedChange">全部下级机构</el-checkbox>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, filterByName, Routes } from '../../app.vues'

    import userApi from '../../api/user'
    import servicerApi from '../../api/servicer'

    import SwbRealComTree from '../orgStruct/RealComTree';
    Vue.regist(SwbRealComTree);

    export default {
        name: 'swb-popover-org-tree',
        desc: '组织架构树组件',
        props: {
            showIncludeSubComs: { // 显示跨组织勾选
                type: Boolean,
                default: false
            },
            initIncludeSubComs: { // 设置初始值
                type: Boolean,
                default: false
            },
            isCom: {    // 是否获取全部的公司
                type: Boolean,
                default: false
            },
            accordion: {    // 是否手风琴模式
                type: Boolean,
                default: false
            },
            isSelectThisLevel: { //本级是否可选
                type: Boolean,
                default: false
            },
            includeUnOpenedFlag: { //是否包含未开店
                type: Boolean,
                default: false
            },
            selectComId: {
                type: Number,
                default: null
            },
            closedComSelect: {
                type: Boolean,
                default: false
            },
            departFlag: {
                type: Boolean,
                default: false
            },
            bizDepart: {
                type: Boolean,
                default: false
            },
            showRealCom: { // 展示实体公司组织机构
                type: Boolean,
                default: false
            },
            onlyShowRealCom: { // 仅展示实体公司组织机构
                type: Boolean,
                default: false
            },
            costFlag: { // 是否获取成本中心
                type: Boolean,
                default: false
            },
            prftFlag: { // 是否获取利润中心
                type: Boolean,
                default: true
            },
            selectRealComId: {  // 当前实体公司Id
                type: Number,
                default: null
            },
        },
        watch: {},
        data: function () {
            return {
                includeSubComs: false,
                itemInfo: {},
                displayName: '',
                showFlag: false,
                tableState: [{
                    "text": "人事组织机构",
                    "value": 0,
                }],
                checkStateValue: 0,
            }
        },
        created: function () {
            let tableState = this.tableState || [];
            if(Utils.isTrue(this.onlyShowRealCom)) {
                tableState = [];
                tableState.push({
                    "text": "公司组织机构",
                    "value": 2,
                });
                this.checkStateValue = 2;
            } else {
                if(Utils.isTrue(this.showRealCom)) {
                    tableState.push({
                        "text": "公司组织机构",
                        "value": 2,
                    });
                }
            }
            this.tableState = Utils.merge([], tableState);
            //
            this.includeSubComs = this.initIncludeSubComs || false;
            if(this.selectComId != null) {
                this.getComInfo(this.selectComId);
            }
        },
        methods: {
            notityChange: function (data) {
                let self = this;
                if(data.id != this.itemInfo.id) {
                    if(data.level <= 4) {
                        data.includeSubComs = this.includeSubComs;
                    }
                    this.itemInfo = data;
                    //
                    this.displayOrgName();
                    //
                    this.$emit('notity-change', data);
                    self.$refs["popover-org-tree"].doClose();
                }
            },
            notityInitChange: function (data) {
                if(this.selectComId == null) {
                    if(data.level <= 4) {
                        data.includeSubComs = this.includeSubComs;
                    }
                    this.itemInfo = Utils.merge({}, data);
                    //
                    if(!data.shopFlag || this.bizDepart) {
                        this.showFlag = true;
                    }
                    //
                    this.displayOrgName();
                    //
                    this.$emit('notity-init-change', data);
                    //
                    if(Utils.isTrue(data.realFlag) && Utils.isTrue(this.onlyShowRealCom)) {
                        this.$emit('notity-change', data);
                    }
                }
            },
            handleCheckedChange: function () {
                let data = this.itemInfo;
                if(data.level <= 4) {
                    data.includeSubComs = this.includeSubComs;
                }
                this.itemInfo = Utils.merge({}, data);
                //
                this.displayOrgName();
                //
                this.$emit('notity-change', data);
            },
            getComInfo: function (comId) {
                let self = this;
                let postData = {
                    comId: comId
                };
                servicerApi.getServicerCom(postData, function (result) {
                    if(result != null && result.type == 'info') {
                        let data = result.data;
                        //
                        if(data.level <= 4) {
                            data.includeSubComs = this.includeSubComs;
                        }
                        self.itemInfo = Utils.merge({}, data);
                        self.displayOrgName();
                        //
                        self.$emit('notity-init-change', data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            displayOrgName: function () {
                let self = this;
                let itemInfo = this.itemInfo;
                self.displayName = itemInfo.name;
            },
            handleTabClick(val) {
                this.checkStateValue = val;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/PopoverOrgTree.vue